import styled from '@emotion/styled'
import {theme} from '../../features/Dashboard/theme'

export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 10px 15px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`
export const PerPageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 480px) {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }
`

export const PerPageGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${theme.colors.text};
`

export const PerPageSelect = styled.select`
  padding: 5px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.md};
  font-size: 13px;
  color: ${theme.colors.muted};
  cursor: pointer;
  outline: none;
  appearance: auto;
  width: 60px;

  &:focus {
    border-color: ${theme.colors.muted};
  }
`

export const ResultsInfo = styled.span`
  font-size: 13px;
  color: ${theme.colors.muted};
`

export const PageButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const PageBtn = styled.button`
  min-width: 28px;
  padding: 3px 6px;
  border: 1px solid
    ${props => (props.active ? theme.colors.primary : theme.colors.border)};
  border-radius: ${theme.radius.md};
  background: ${props => (props.active ? '#0327A9' : 'none')};
  color: ${props => (props.active ? theme.colors.surface : theme.colors.muted)};
  font-size: 13px;
  font-weight: ${props => (props.active ? '600' : '400')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  transition: all ${theme.transition.fast};
  white-space: nowrap;

  &:hover:not([disabled]) {
    ${props =>
      !props.active &&
      `background: ${theme.colors.hover}; border-color: ${theme.colors.border};`}
  }

  &:focus {
    outline: none;
  }
`

export const Ellipsis = styled.span`
  padding: 0 4px;
  color: ${theme.colors.placeholder};
  font-size: 14px;
  display: flex;
  align-items: center;
`
